import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { HashLink } from "react-router-hash-link";

function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === "/";

  const toggleMenu = () => setMenuOpen(!menuOpen);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    handleScroll(); // Check on mount
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <nav className={`top-0 left-0 w-full z-50 text-gold px-6 py-4 transition duration-300 ${
      isHome ? `fixed ${scrolled ? "bg-deepgreen shadow-md" : "bg-transparent"}` : "sticky bg-deepgreen shadow-md"
    }`}>
      <div className="max-w-7xl mx-auto flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3">
          <img
            src="/enw-logo.png"
            alt="ENW Advocates Logo"
            className="h-12 w-auto object-contain animate-logo"
          />
          <span className="text-2xl font-bold tracking-tight">ENW Advocates</span>
        </Link>

        <button
          className="md:hidden text-gold focus:outline-none"
          onClick={toggleMenu}
        >
          {menuOpen ? "Close" : "Menu"}
        </button>

        <ul className="hidden md:flex gap-6 text-lg font-medium">
          <li><Link to="/">Home</Link></li>
          <li><HashLink smooth to="/#about">About</HashLink></li>
          <li><HashLink smooth to="/#services">Services</HashLink></li>
          <li><Link to="/team">Team</Link></li>
          <li><HashLink smooth to="/#contact">Contact Us</HashLink></li>
        </ul>
      </div>

      {menuOpen && (
        <ul className="md:hidden mt-4 flex flex-col gap-4 text-lg font-medium bg-black/70 px-4 py-6 rounded-lg backdrop-blur-sm">
          <li><Link to="/" onClick={toggleMenu}>Home</Link></li>
          <li><HashLink smooth to="/#about" onClick={toggleMenu}>About</HashLink></li>
          <li><HashLink smooth to="/#services" onClick={toggleMenu}>Services</HashLink></li>
          <li><Link to="/team" onClick={toggleMenu}>Team</Link></li>
          <li><HashLink smooth to="/#contact" onClick={toggleMenu}>Contact</HashLink></li>
        </ul>
      )}
    </nav>
  );
}

export default Navbar;
